<template>
    <v-container fluid class="form-content overflow-auto pa-5">
        <v-form ref="form" @input="$emit('input', $event)">
            <h4 class="mt-5 mb-2">{{ $t('kulturverbund') }}</h4>
            <v-row dense>
                <v-col cols="12" md="6">
                    <LabelField :label="$t('bezeichnung')">
                        <v-text-field
                            hide-details="auto"
                            :value="recordToEdit?.title"
                            :rules="[rules.required, rules.maxLength(45)]"
                            :counter="45"
                            dense
                            outlined
                            @input="recordToEdit?.set('title', $event)"
                        />
                    </LabelField>
                </v-col>
                <v-col cols="12" md="6">
                    <LabelField :label="$t('id')">
                        <v-text-field
                            hide-details="auto"
                            :value="recordToEdit?.id"
                            disabled
                            dense
                            outlined
                            @input="recordToEdit?.set('id', $event)"
                        />
                    </LabelField>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <LabelField :label="$t('description')">
                        <v-textarea
                            hide-details="auto"
                            :value="recordToEdit?.description"
                            :rules="[rules.required]"
                            dense
                            outlined
                            @input="recordToEdit?.set('description', $event)"
                        />
                    </LabelField>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <LabelField :label="$t('event_organizer')">
                        <MultiSelect
                            item-text="title"
                            item-value="id"
                            query-param="title_query"
                            :value="recordToEdit?.veranstalter_list"
                            :collection-class="EventOrganizerCollection"
                            @input="onEventOrganizerSelect"
                            @loading="$emit('loading', $event)"
                        >
                            <template #item="{ parent, item, on, attrs }">
                                <slot name="item" :parent="parent" :item="item" :on="on" :attrs="attrs">
                                    <AddressComboListItem :item="item" />
                                </slot>
                            </template>
                        </MultiSelect>
                    </LabelField>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import { OrganizerGroup } from '@/models/OrganizerGroup';
import { EventOrganizerCollection } from '@/models/EventOrganizer';
import { formRules } from '@/helpers/tools';
import { mapActions } from 'vuex';
import AddressComboListItem from '../address/AddressComboListItem.vue';
import MultiSelect from '../form/MultiSelect.vue';

export default {
    name: 'OrganizerGroupEditForm',
    components: { AddressComboListItem, MultiSelect },

    props: {
        record: {
            type: OrganizerGroup,
            default: null,
        },
    },

    data() {
        return {
            recordToEdit: null,
        };
    },

    watch: {
        record: {
            handler(newValue) {
                this.recordToEdit = newValue?.clone() || new OrganizerGroup();
            },
            immediate: true,
        },
    },

    created() {
        this.rules = formRules;
        this.EventOrganizerCollection = EventOrganizerCollection;
    },

    mounted() {
        this.validateForm();
    },

    methods: {
        ...mapActions(['runAsync']),

        validateForm() {
            this.$refs.form?.validate();
        },

        async save() {
            const { recordIsNew, recordChanged } = await this.saveRecord();

            if (recordIsNew) {
                this.$emit('record-added', this.recordToEdit);
            } else if (recordChanged) {
                this.$emit('record-changed', this.recordToEdit);
            }
            return this.recordToEdit;
        },

        async saveRecord() {
            const recordIsNew = this.recordToEdit?.isPhantom() ?? false;
            const recordSaveNeeded = this.recordToEdit?.hasUnsavedData() ?? false;
            if (recordSaveNeeded) {
                await this.runAsync(async () => await this.recordToEdit.save());
            }
            return {
                recordIsNew,
                recordChanged: recordSaveNeeded,
            };
        },

        onEventOrganizerSelect(value) {
            this.recordToEdit?.set('veranstalter_list', value);
        },
    },
};
</script>
